import { state } from '@/store';

/** Имя и email для формы ОС: локальный профиль страницы или глобальный state.user. */
export function feedbackIdentityPrefill(localUser) {
  const u = localUser || {};
  return {
    name: u.first_name || state.user?.first_name || '',
    email: u.email || state.user?.email || '',
  };
}
